module.exports = __webpack_public_path__ + "static/catch-a8154e1a5400bc8d62e89c76c23aa813.jpg";